import { SecurityLevel, UserRoleEnum } from "@/__generated__/graphql";

export const REDUCED_PAGINATION_LIMIT = 25;
export const INVOICE_SHOTS_PAGINATION_LIMIT = 20;
export const UI_FADE_DURATION = 5000;
//date.ts
export const TIME_FORMAT_MONTH_DAY = "MMM D";
export const TIME_FORMAT_MONTH_DAY_YEAR = "MMM D, YYYY";
export const DATE_TIME_FORMAT = "y-MM-dd'T'HH:mm:ss.SSSSxx";
export const MONTH_DAY_YEAR_FORMAT = "MMM dd yyyy";
export const TIMEZONE_FORMAT = "MMM D - HH:mm A (z)";

//money.ts
export const DEFAULT_CURRENCY = "USD";

export enum ExportModalType {
  INVOICES,
}
import { TaskShotBidStatus, UserRole } from "@/__generated__/graphql";

export const STATUS_LIST_IN_PROGRESS = [
  TaskShotBidStatus.Awarded,
  TaskShotBidStatus.Resumed,
  TaskShotBidStatus.RevisionRequested,
];
export const STATUS_LIST_PENDING = [
  TaskShotBidStatus.Pending,
  TaskShotBidStatus.PendingStateChange,
];
export const STATUS_LIST_COMPLETED = [
  TaskShotBidStatus.Delivered,
  TaskShotBidStatus.Approved,
  TaskShotBidStatus.Cancelled,
];
export const STATUS_LIST_AWARDED = [
  ...STATUS_LIST_IN_PROGRESS,
  ...STATUS_LIST_COMPLETED,
];
export const STATUS_LIST_ASSIGNED = [
  ...STATUS_LIST_AWARDED,
  TaskShotBidStatus.PendingStateChange,
  TaskShotBidStatus.Invoiced,
];
export const STATUS_LIST_CANCELLABLE = [
  TaskShotBidStatus.Awarded,
  TaskShotBidStatus.Resumed,
  TaskShotBidStatus.RevisionRequested,
];
export const STATUS_LIST_RESUMABLE = [TaskShotBidStatus.Cancelled];

export const userRoles = {
  [UserRole.Admin]: "Admin",
  [UserRole.Collaborator]: "Collaborator",
  [UserRole.Reviewer]: "Reviewer",
};

export const USER_ROLE_ACCESS: { [k in UserRoleEnum]: string } = {
  [UserRoleEnum.Admin]:
    "Can add/edit users. Has access to projects and the financial dashboard",
  [UserRoleEnum.Collaborator]:
    "Has access to projects and can view/approve costs",
  [UserRoleEnum.Reviewer]:
    "Has access to projects. Cannot view/approve any costs",
};
export const INVITE_TOKEN_TIMEOUT_SECONDS = 72 * 60 * 60;
export const DASHBOARD_PAGINATION_LIMIT = 20;
export const NOTIFICATION_PAGINATION_LIMIT = 20;
export const RECENT_MESSAGES_PAGINATION_LIMIT = 20;
export const PROJECTS_PAGINATION_LIMIT = 20;
export const PENDING_PAGINATION_LIMIT = 20;
export const ASSETS_PAGINATION_LIMIT = 20;

// IMPORTANT: Must match FILE_CHUNK_SIZE in hotspring/settings.py
export const FILE_CHUNK_SIZE = 10 * 1024 * 1024;
export const MAX_REQUESTS_COUNT = 5;

export const RESTRICTED_TIER_LEVEL = [
  SecurityLevel.Tier_1,
  SecurityLevel.Tier_2,
];

export const HOTSPRING_VM_STATUS_POLLING_TIME = 5 * 1000;

export const TASK_SHOTS_QUERY_PARAM = "taskShotIds";
